export default function buttonDisable(statusId, userType) {
    // console.log('statusId, userType', statusId, userType)
    if (userType === 'L1 CRC Confirmed') {
        return (statusId === 3) || (statusId === 4) ? '' : 'disabled';
    }
    if (userType === 'L2 CRC Confirmed') {
        return (statusId === 7) || (statusId === 8) ? '' : 'disabled';
    }
    if (userType === 'EM Confirmed') {
        return (statusId === 10) ? '' : 'disabled';
    }
    if (userType === 'L1 AM Confirmed') {
        return (statusId === 5) ? '' : 'disabled';
    }
    if (userType === 'Detailed Analysis') {
        return (statusId === 10 || statusId === 13 || statusId === 14) ? '' : 'disabled';
    }
    if (userType === 'Draft Statements') {
        return (statusId === 16) || (statusId === 17) || (statusId === 18 && window.location.pathname === '/menu/imc-add-draft') ? '' : 'disabled';
    }
    if (userType === 'Tax Payment and Filing') {
        return (statusId === 19 || statusId === 21) ? '' : 'disabled';
    }
    if (userType === 'Tax Payment and Filing by Client') {
        return (statusId === 20) ? '' : 'disabled';
    }
    if (userType === 'Final Statement') {
        return (statusId === 19) ? '' : 'disabled';
    }
    if (!statusId || !userType.value) {
        return 'disabled';
    }

}